import { Injectable } from '@angular/core';
import { WeakStrongPair } from '@modules/common/models/weak-strong-pair';

const DEVICE_TOKEN_KEY = "device-token";

@Injectable({
    providedIn: 'root'
})
export class DeviceTokenService {
    public getDeviceToken(): WeakStrongPair | undefined {
        let json = localStorage.getItem(DEVICE_TOKEN_KEY);
        return json && JSON.parse(json);
    }

    public setDeviceToken(deviceToken: WeakStrongPair): void {
        localStorage.setItem(DEVICE_TOKEN_KEY, deviceToken && JSON.stringify(deviceToken));
    }
}
